import React, { useState } from "react";
import { Modal, Button, TextField, Grid, Typography, Switch, Select, MenuItem, FormControl, InputLabel, SelectChangeEvent, OutlinedInput, Box, Chip, useTheme, Theme, IconButton } from "@mui/material";
import { SessionInfo, SessionSpeaker } from "../../data/SessionData";
import { useGlobal } from "../../utils/GlobalContext";
import { UserInfo, newUserInfo } from "../../data/userInfo";
import EditIcon from "@mui/icons-material/Edit";
import "./SaveAdminSessionModal.css";
import { EventInfo} from "../../data/eventInfo";
import Editor from "../../utils/RTEditor";

interface SaveAdminSessionModalProps {
  usersInfo: UserInfo[];
  session: SessionInfo;
  currentEvent: EventInfo;
  isOpen: boolean;
  onClose: () => void;
  onSave: (updatedSession: SessionInfo) => void;
}



const ITEM_HEIGHT = 50;
const ITEM_PADDING_TOP = 9;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const SaveAdminSessionModal: React.FC<SaveAdminSessionModalProps> = ({
  usersInfo,
  session,
  currentEvent,
  isOpen,
  onClose,
  onSave,
}) => {
  const { state, dispatch } = useGlobal();
  const [editingUserId, setEditingUserId] = useState<string | null>(null);
  const [validationError, setValidationError] = useState<string | null>(null);
  const [isSessionChanged, setIsSessionChanged] = useState<boolean>(false);
  const [updatedSession, setUpdatedSession] = useState<SessionInfo>(() => {
    if (!session.Id) {
      // If session doesn't have an Id, it's a new session, so initialize IsWorkshop to false
      return {
        ...session,
        IsWorkshop: false,
      };
    }
    // Otherwise, return the session as it is
    return { ...session };
  });
const getStatusColor = (status: number): string => {
  switch (status) {
    case 1: // Pending
      return '#FFA500'; // Orange
    case 2: // Rejected
      return '#FF0000'; // Red
    case 3: // Accepted
      return '#008000'; // Green
    default:
      return '#000000'; // Black (default color)
  }
};


  const theme = useTheme();

  console.log(updatedSession);

  console.log("Workshop is: "+currentEvent.IsWorkshopSessionAllowed);
  const FirstName = state.UserProfile.FirstName.toString();
  const LastName = state.UserProfile.LastName.toString();



  
  const handleSave = () => {
    // if (!selectedEventId) {
    if (!updatedSession.Description || !updatedSession.Title) {
      setValidationError("Description and Title cannot be empty.");
    } else {
      onSave(updatedSession);
      onClose();
      setValidationError(null); // Reset validation error when saving succeeds
    }
  };

  const handleTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setUpdatedSession((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleEditorSave = (editorContent: string) => {
    //setDescription(editorContent);
    setUpdatedSession(prevState => ({
      ...prevState,
      Description: editorContent
    }));
  };


  const handleSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setUpdatedSession((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };
  //-------------------------------------------------------------------------
  const [selectedUsers, setSelectedUsers] = useState<SessionSpeaker[]>(() => {
    // Initialize selected users with the existing session speakers
    return session.SessionSpeakers || [];
  });
  const [isCreatingSession, setIsCreatingSession] = useState<boolean>(() => {
    // If session doesn't have an Id, it's a new session
    return !session.Id;
  });
  const getStyles = (userId: string | undefined, selectedUsers: SessionSpeaker[], theme: Theme) => {
    if (!userId) {
      return {}; // Return an empty object if userId is undefined
    }
  
    const isSelected = selectedUsers.some((user) => user.UserId === userId);
    return {
      fontWeight: isSelected
        ? theme.typography.fontWeightMedium
        : theme.typography.fontWeightRegular,
      backgroundColor: isSelected
        ? theme.palette.primary.light 
        : theme.palette.background.paper, 
      color: isSelected
        ? theme.palette.primary.main 
        : theme.palette.text.primary, 
    };
  };
  
  const handleSelectChange = (e: SelectChangeEvent<any>) => {
    const selectedIds = e.target.value || []; // Ensure selectedIds is an array

    // Ensure session owner ID is always selected
    const sessionOwnerId = updatedSession.UserId || "";
    if (!selectedIds.includes(sessionOwnerId)) {
        selectedIds.push(sessionOwnerId);
    }

    // Check if all users are unselected, then set SessionSpeakers to null
    if (selectedIds.length === 0) {
        setUpdatedSession((prevState) => ({
            ...prevState,
            SessionSpeakers: [],
        }));
        setSelectedUsers([]); // Clear selected users
        return; // Exit function early
    }

    // Find selected users based on their IDs and convert them to SessionSpeaker objects
    const selectedSpeakers = usersInfo
        .filter((user) => selectedIds.includes(user.Id || ""))
        .map((user) => ({
            UserId: user.Id || "",
            SpeakerEmail: user.Email || "",
            FirstName: user.FirstName || "",
            LastName: user.LastName || "",
            SpeakerName: `${user.FirstName || ""} ${user.LastName || ""}`,
            PictureLink: user.PictureLink || null,
            SpeakerResponseStatus: isCreatingSession
                ? 3
                : getSpeakerResponseStatusFromSession(user), // Set SpeakerResponseStatus based on whether creating or editing
        }));

    // Update selected users separately
    setSelectedUsers(selectedSpeakers);

    // Update the SessionSpeakers directly with the selected users
    setUpdatedSession((prevState) => {
        // Filter out selectedSpeakers already present in prevState.SessionSpeakers
        const updatedSpeakers = selectedSpeakers.filter(
            (selectedSpeaker) =>
                !(prevState.SessionSpeakers || []).some(
                    (speaker) => speaker.UserId === selectedSpeaker.UserId
                )
        );

        return {
            ...prevState,
            SessionSpeakers: [
                ...(prevState.SessionSpeakers || []).filter((speaker) =>
                    selectedIds.includes(speaker.UserId)
                ), // Ensure prevState.SessionSpeakers is an array
                ...updatedSpeakers,
            ],
        };
    });
};

  

  const getSpeakerResponseStatusFromSession = (user: UserInfo): number => {
    const sessionSpeaker = updatedSession.SessionSpeakers.find(
      (speaker) => speaker.UserId === user.Id
    );
    return sessionSpeaker ? sessionSpeaker.SpeakerResponseStatus : 3; // Default to 3 if not found
  };

  const handleSpeakerStatusChange = (event: SelectChangeEvent<any>) => {
    const status = event.target.value;
  
    // Update the selectedUsers array with the new SpeakerResponseStatus
    const updatedUsers = selectedUsers.map((user) => {
      if (user.UserId === editingUserId) {
        return {
          ...user,
          SpeakerResponseStatus: status,
        };
      }
      return user;
    });
  
    // Update the selectedUsers state with the updated array
    setSelectedUsers(updatedUsers);
  
    // Update the SessionSpeakers array in updatedSession with the updated users
    setUpdatedSession((prevState) => ({
      ...prevState,
      SessionSpeakers: updatedUsers,
    }));
  
  };
  // Check if session has changed whenever updatedSession changes
  React.useEffect(() => {
    setIsSessionChanged(
      JSON.stringify(updatedSession) !== JSON.stringify(session)
    );
  }, [updatedSession, session]);

  return (
    <div style={{ width: '100%', height: '100%' }}>
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="edit-session-modal"
      aria-describedby="modal-to-edit-session"
      className="edit-session-modal"
    >
      <div className="edit-session-modal-content">
        <form>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={12}>
              <Typography variant="h5" component="h2" align="center">
                {session.Id ? "Edit Session" : "Create Session"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
            <Typography variant="h6" component="h2">
              {session.Id
                ? updatedSession.SessionSpeakers && updatedSession.SessionSpeakers[0]
                  ? "Session submitter: " +
                    updatedSession.SessionSpeakers[0].FirstName +
                    " " +
                    updatedSession.SessionSpeakers[0].LastName
                  : "Session submitter: Unknown"
                : FirstName && LastName
                ? "Session submitter: " + FirstName + " " + LastName
                : "Session submitter: Unknown"}
            </Typography>

            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                name="Title"
                label="Title"
                value={updatedSession.Title}
                onChange={handleTextFieldChange}
              />
            </Grid>
            <Grid item xs={12}>
            
                <Typography variant="h6" component="h2">
                  Description
                </Typography>
              <div className="EditorContainer">
                <Editor
                  editorName="editor"
                  content={updatedSession.Description}
                  saveContent={handleEditorSave}
                  showSaveButton={false}
                />
              </div>
            </Grid>
            <Grid item xs={12} className="workshop-text" justifyContent="center">
              <TextField
                fullWidth
                name="AdditionalNotes"
                id="outlined-multiline-static"
                label="AdditionalNotes"
                multiline
                rows={5}
                value={updatedSession.AdditionalNotes}
                onChange={handleTextFieldChange}
              />
            </Grid>
            
             
            <Grid item xs={12} container direction="row" alignItems="center">
              <Typography variant="h6" component="h2">
                Select Other Presenters :
              </Typography>
              {/* Display existing session speakers as chips */}
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, alignItems: "center" }}>
                {selectedUsers.length > 0 && selectedUsers.map((value) => (
                  <Box key={value.UserId} sx={{ display: "flex", alignItems: "center" }}>
                    <Chip
                      avatar={<img src={value.PictureLink || ""} alt={`${value.FirstName} ${value.LastName}`} style={{ maxWidth: "30px", maxHeight: "30px", borderRadius: "50%" }} />}
                      label={(
                        <Typography style={{ color: "white" }}>
                          {`${value.FirstName} ${value.LastName}`}
                        </Typography>
                      )}
                      style={{
                        backgroundColor: getStatusColor(value.SpeakerResponseStatus)
                      }}
                    />

                    <IconButton              
                      onClick={() => setEditingUserId(value.UserId)}
                      size="small"
                    >
                      <EditIcon color="action" />
                    </IconButton>
                    {editingUserId === value.UserId && (
                      <FormControl>
                        <InputLabel id="status-select-label">Status</InputLabel>
                        <Select
                          labelId="status-select-label"
                          id="status-select"
                          value={value.SpeakerResponseStatus}
                          onChange={handleSpeakerStatusChange}
                          label="Status"
                          onBlur={() => setEditingUserId(null)} 
                        >
                          <MenuItem value={1}>Pending</MenuItem>
                          <MenuItem value={2}>Rejected</MenuItem>
                          <MenuItem value={3}>Accepted</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  </Box>
                ))}
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Select
                label="Select Other Presenters"
                name="SessionSpeakers"
                multiple
                value={selectedUsers.map(user => user.UserId)}
                onChange={handleSelectChange}
                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                MenuProps={MenuProps}
                sx={{ width: "100%", minWidth: "200px" }}
              >
                {usersInfo.map((user) => (
                  <MenuItem key={user.Id} value={user.Id} style={getStyles(user.Id, selectedUsers, theme)}>
                    {`${user.FirstName} ${user.LastName} - ${user.Email}`}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item xs={12}>
              {!selectedUsers.length && (
                <Typography variant="body2" color="error" align="center">
                  One presenter is need it.
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sx={{ padding: '25px' }}>
              <div>
                {updatedSession && updatedSession.SpeakerRequests && updatedSession.SpeakerRequests.length > 0 && (
                  <div>
                    <Typography variant="h6" component="h2">
                      Speaker Requests 
                    </Typography>
                    {updatedSession.SpeakerRequests.map((request, index) => (
                      <Chip key={index} sx={{ margin: '3px' }} label={request}/>
                    ))}
                  </div>
                )}
              </div>
            </Grid>

            <Grid container>
              <Grid
                item
                xs={6}
                container
                direction="row"
                alignItems="center"
                justifyContent="center"
              >
                <Typography variant="h6" component="h2" align="center">
                  Would the Session be a Workshop?
                </Typography>
                <Switch
                  name="IsWorkshop"
                  checked={updatedSession.IsWorkshop}
                  onChange={handleSwitchChange}
                  disabled={!currentEvent.IsWorkshopSessionAllowed}
                  color={updatedSession.IsWorkshop ? "info" : "info"}
                />
              </Grid>
              <Grid
                item
                xs={6}
                container
                direction="row"
                alignItems="center"
                justifyContent="center"
              >
                <Typography variant="h6" component="h2" align="center">
                  Would the session be a keynote?
                </Typography>
                <Switch
                  name="IsKeynote"
                  checked={updatedSession.IsKeynote}
                  onChange={handleSwitchChange}
                  color={updatedSession.IsKeynote ? "info" : "info"}
                />
              </Grid>
              <Grid item xs={12}>
              {!currentEvent?.IsWorkshopSessionAllowed && (
                <Typography variant="body2" color="error" align="center">
                  This Event does not allow Workshops.
                </Typography>
              )}
            </Grid>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="VideoLink"
                label="Video URL"
                value={updatedSession.VideoLink}
                onChange={handleTextFieldChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="VideoThumbnail"
                label="Video Thumbnail"
                value={updatedSession.VideoThumbnail}
                onChange={handleTextFieldChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" component="h2" align="center">
                Approve or Deny Session
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              container
              justifyContent="center"
              alignItems="center"
            >
              <Switch
                name="IsSelected"
                checked={updatedSession.IsSelected}
                onChange={handleSwitchChange}
                color="info"
              />
            </Grid>

            <Grid
              item
              xs={12}
              container
              justifyContent="center"
              alignItems="center"
            >
                {validationError && (
              <Grid item xs={12}>
                <Typography variant="body2" color="error" align="center">
                  {validationError}
                </Typography>
              </Grid>
            )}
              <Button onClick={onClose} className="CancelButtonStyle">
                Cancel
              </Button>
              <Button
                onClick={handleSave}
                className="ButtonStyle"
                disabled={!isSessionChanged} // Disable Save button if no changes made
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
    </Modal>
    </div>
  );
};

export default SaveAdminSessionModal;
